import { combineReducers } from 'redux';

import account from './Account';
import sessionData from './SessionData';
import showColumns from './ShowColumns';
import tableData from './TableData';
import tempData from './TempData';

const app = combineReducers({
  account,
  tableData,
  sessionData,
  showColumns,
  tempData,
});

export default app;
